var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupBird({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 176,
    viewBox: "0 0 194 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 129.72L56.5509 120.161C67.646 125.082 72.2803 118.369 74.6181 114.72C76.9559 111.071 76.803 110.693 79.2568 109.214C81.7106 107.734 82.0061 104.669 78.418 103.099C75.1461 101.667 71.0208 106.341 68.619 104.836C57.936 98.2164 57.0325 76.8838 57.0866 68.6842C57.0887 67.1947 51.6244 68.5745 52.5839 73.1222C52.8073 74.1855 52.0733 73.5468 51.2803 72.4933L49.3651 69.9508C48.9578 69.3967 45.6611 71.5697 47.7251 74.9744C48.0776 75.5499 48.4511 76.1216 48.6981 76.5667C49.1963 77.4327 48.3205 76.8356 47.151 76.1228C47.151 76.1228 44.2976 74.3879 43.7934 74.07C43.2893 73.7522 40.489 76.4535 44.0384 79.7307C44.7156 80.3511 45.3648 81.05 45.7481 81.451C46.458 82.1895 45.8264 82.1333 44.8469 81.7435C44.8469 81.7435 40.0436 79.5051 39.7984 79.7088C39.5533 79.9126 37.404 83.2941 42.7844 86.7377C43.0621 86.8885 43.3523 87.0155 43.6515 87.1172C44.7922 87.5841 43.8258 87.8026 42.4562 87.7993C42.4562 87.7993 38.8298 87.7414 38.1138 87.4474C37.3977 87.1535 36.6418 92.577 43.2731 93.8011C44.6184 94.0529 43.4978 94.3271 42.0654 94.9573C42.0654 94.9573 34.958 97.2703 44.5901 99.581C43.7246 100.084 42.8058 100.491 41.8505 100.793C39.0431 101.417 44.1231 105.027 48.103 105.272C48.9734 105.154 48.8437 106.089 45.5932 107.414C45.0166 107.647 46.0937 109.907 49.6944 109.371C50.1598 109.302 50.6224 109.285 51.0493 109.245C51.33 109.212 49.1594 109.94 49.343 110.753C49.4976 111.469 53.1297 112.196 52.5608 112.22C52.5608 112.22 31.0657 111.508 32.1635 113.245C33.6277 115.571 40.1578 115.111 40.1578 115.111C40.1578 115.111 31.4481 116.483 31.2338 117.686C31.0195 118.888 41.3156 118.405 41.3156 118.405C41.3156 118.405 31.4274 121.088 31.9801 123.151C32.5327 125.214 43.2209 121.014 43.2209 121.014C43.2209 121.014 35.9358 125.025 36.7279 126.214C37.52 127.403 45.2811 123.478 45.2811 123.478C45.2811 123.478 38.3785 129.762 40.5946 130.058C40.9592 130.066 41.3147 129.946 41.6 129.72Z",
    fill: "url(#paint0_linear_1335_58653)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4363 86.9395L53.0078 91.7763L58.0936 91.7763L53.9791 94.7657L55.5507 99.6026L51.4363 96.6132L47.3218 99.6026L48.8934 94.7657L44.7789 91.7763L49.8647 91.7763L51.4363 86.9395Z",
    fill: "#FFFA66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4302 103.447C72.2413 104.336 70.1012 105.752 68.6229 104.839C65.9767 103.195 63.9279 100.646 62.3387 97.6107C61.9936 95.934 61.7932 94.2312 61.7399 92.5209C62.6843 93.6146 63.7458 95.1679 63.7458 95.1679C64.4728 95.9267 64.9157 95.9392 64.5926 94.9553C64.4344 94.426 64.1499 93.5174 63.818 92.6723C62.062 88.1776 66.2488 87.0293 66.5729 87.521C66.897 88.0128 69.3289 93.6651 69.1441 92.677C67.8926 86.1093 72.7732 85.5432 72.907 86.2174C73.0408 86.8916 73.4909 89.3372 73.4909 89.3372C73.7597 90.6083 73.9537 92.3327 74.1695 91.2607C75.5118 84.7201 81.0466 87.1426 80.3848 88.447C77.981 93.2705 75.9891 98.2883 74.4302 103.447Z",
    fill: "url(#paint1_linear_1335_58653)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.4302 103.447C72.2413 104.336 70.1012 105.752 68.6229 104.839C65.9767 103.195 63.9279 100.646 62.3387 97.6107C61.9936 95.934 61.7932 94.2312 61.7399 92.5209C62.6843 93.6146 63.7458 95.1679 63.7458 95.1679C64.4728 95.9267 64.9157 95.9392 64.5926 94.9553C64.4344 94.426 64.1499 93.5174 63.818 92.6723C62.062 88.1776 66.2488 87.0293 66.5729 87.521C66.897 88.0128 69.3289 93.6651 69.1441 92.677C67.8926 86.1093 72.7732 85.5432 72.907 86.2174C73.0408 86.8916 73.4909 89.3372 73.4909 89.3372C73.7597 90.6083 73.9537 92.3327 74.1695 91.2607C75.5118 84.7201 81.0466 87.1426 80.3848 88.447C77.981 93.2705 75.9891 98.2883 74.4302 103.447Z",
    fill: "url(#paint2_linear_1335_58653)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0795 106.221C81.0795 106.221 79.9345 107.1 80.3522 108.313C80.3522 108.313 83.0397 108.809 83.6875 110.194C83.6974 110.231 84.1039 107.045 81.0795 106.221Z",
    fill: "url(#paint3_linear_1335_58653)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3632 105.6C79.3199 105.699 79.2481 105.782 79.157 105.841C79.0658 105.899 78.9594 105.929 78.8512 105.926C78.743 105.924 78.6378 105.89 78.5489 105.828C78.46 105.766 78.3915 105.679 78.352 105.579C78.3124 105.478 78.3036 105.368 78.3268 105.262C78.3499 105.157 78.4039 105.061 78.4818 104.986C78.5598 104.911 78.6583 104.861 78.7649 104.842C78.8715 104.823 78.9813 104.836 79.0805 104.88C79.2136 104.938 79.3181 105.047 79.3711 105.182C79.4241 105.317 79.4213 105.467 79.3632 105.6Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.936 93.5889L107.959 89.7449C112.437 91.7045 114.292 89.0238 115.236 87.5511C116.179 86.0783 116.115 85.9273 117.11 85.3323C118.105 84.7373 118.216 83.503 116.771 82.8705C115.462 82.2977 113.796 84.1603 112.821 83.5654C108.516 80.9032 108.152 72.3069 108.157 68.9848C108.16 68.3836 105.956 68.9354 106.338 70.7807C106.429 71.2096 106.136 70.945 105.792 70.542L105.02 69.5168C104.853 69.2884 103.535 70.1629 104.361 71.5418C104.501 71.7715 104.654 72.0006 104.735 72.172C104.937 72.5263 104.583 72.2807 104.11 71.9959L102.764 71.1669C102.558 71.0443 101.428 72.1247 102.856 73.4495C103.131 73.6991 103.39 73.9813 103.548 74.141C103.833 74.4406 103.581 74.408 103.184 74.2603C102.529 73.9336 101.849 73.6599 101.151 73.4418C101.051 73.5213 100.187 74.8863 102.354 76.2752C102.465 76.337 102.582 76.3882 102.703 76.428C103.155 76.6261 102.771 76.7039 102.219 76.7022C101.63 76.7087 101.042 76.6678 100.46 76.5801C100.176 76.456 99.8668 78.6471 102.543 79.1381C103.084 79.2388 102.632 79.3518 102.065 79.5769C102.065 79.5769 99.202 80.5075 103.076 81.4386C102.727 81.641 102.357 81.8049 101.972 81.9274C100.842 82.1781 102.892 83.6261 104.496 83.732C104.843 83.6827 104.788 84.0605 103.475 84.5809C103.245 84.6749 103.682 85.5919 105.125 85.3681C105.313 85.3401 105.502 85.3386 105.666 85.3197C105.83 85.3009 104.897 85.5922 104.973 85.9236C105.049 86.2549 106.504 86.5092 106.282 86.4964C106.282 86.4964 97.6239 86.2062 98.063 86.9103C98.6647 87.8217 101.278 87.6696 101.278 87.6696C101.278 87.6696 97.7854 88.2274 97.6815 88.6873C97.5777 89.1473 101.746 88.976 101.746 88.976C101.746 88.976 97.7583 90.0559 97.9778 90.8906C98.1972 91.7254 102.513 90.0307 102.513 90.0307C102.513 90.0307 99.5783 91.643 99.8938 92.1246C100.209 92.6061 103.338 91.04 103.338 91.04C103.338 91.04 100.555 93.5676 101.446 93.6852C101.53 93.7034 101.617 93.7042 101.701 93.6877C101.786 93.6711 101.866 93.6375 101.936 93.5889Z",
    fill: "url(#paint4_linear_1335_58653)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.936 75.9385L106.722 78.3569L109.265 78.3569L107.208 79.8516L107.993 82.27L105.936 80.7754L103.879 82.27L104.665 79.8516L102.608 78.3569L105.15 78.3569L105.936 75.9385Z",
    fill: "#FFFA66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.163 83.0094C114.279 83.3674 113.419 83.9371 112.821 83.5654C111.73 82.8404 110.854 81.8348 110.287 80.6549C110.147 79.9801 110.066 79.2944 110.047 78.6057C110.427 79.0442 110.876 79.6813 110.876 79.6813C111.172 79.9856 111.35 79.9926 111.218 79.5977C111.156 79.3827 111.044 79.016 110.908 78.6717C110.199 76.8641 111.901 76.4039 112.03 76.5703C112.158 76.7368 113.142 79.0466 113.068 78.6514C112.57 76.0034 114.535 75.7748 114.575 76.0707L114.822 77.3322C114.931 77.8401 115.01 78.5356 115.096 78.1004C115.64 75.4615 117.868 76.4298 117.6 76.9672C116.618 78.9087 115.803 80.93 115.163 83.0094Z",
    fill: "url(#paint5_linear_1335_58653)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.163 83.0094C114.279 83.3674 113.419 83.9371 112.821 83.5654C111.73 82.8404 110.854 81.8348 110.287 80.6549C110.147 79.9801 110.066 79.2944 110.047 78.6057C110.427 79.0442 110.876 79.6813 110.876 79.6813C111.172 79.9856 111.35 79.9926 111.218 79.5977C111.156 79.3827 111.044 79.016 110.908 78.6717C110.199 76.8641 111.901 76.4039 112.03 76.5703C112.158 76.7368 113.142 79.0466 113.068 78.6514C112.57 76.0034 114.535 75.7748 114.575 76.0707L114.822 77.3322C114.931 77.8401 115.01 78.5356 115.096 78.1004C115.64 75.4615 117.868 76.4298 117.6 76.9672C116.618 78.9087 115.803 80.93 115.163 83.0094Z",
    fill: "url(#paint6_linear_1335_58653)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.849 84.1332C117.724 84.2289 117.629 84.3595 117.578 84.5088C117.526 84.6581 117.52 84.8192 117.56 84.9721C117.56 84.9721 118.642 85.1734 118.905 85.7293C118.95 85.3815 118.868 85.0287 118.674 84.7357C118.481 84.4426 118.188 84.2287 117.849 84.1332Z",
    fill: "url(#paint7_linear_1335_58653)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M117.148 83.8789C117.137 83.9053 117.12 83.9292 117.099 83.9492C117.078 83.9692 117.054 83.9848 117.027 83.9953C117 84.0058 116.971 84.0109 116.942 84.0103C116.913 84.0097 116.885 84.0034 116.858 83.9918C116.806 83.9672 116.765 83.9234 116.744 83.8696C116.723 83.8157 116.723 83.7558 116.745 83.7023C116.768 83.6489 116.812 83.607 116.866 83.5859C116.92 83.5647 116.981 83.5659 117.034 83.5894C117.061 83.6003 117.086 83.6166 117.107 83.6373C117.127 83.658 117.143 83.6827 117.154 83.7098C117.164 83.7369 117.169 83.7659 117.168 83.795C117.168 83.8241 117.161 83.8526 117.148 83.8789Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.31 121.996L126.863 119.728C129.503 120.883 130.592 119.299 131.152 118.436C131.711 117.573 131.669 117.477 132.25 117.129C132.832 116.78 132.905 116.048 132.055 115.676C131.204 115.303 130.296 116.442 129.724 116.088C127.166 114.508 126.974 109.454 126.986 107.496C126.989 107.147 125.696 107.475 125.92 108.552C125.973 108.802 125.8 108.648 125.604 108.413L125.146 107.811C125.048 107.678 124.268 108.198 124.761 109.003C124.845 109.137 124.929 109.271 124.991 109.383C125.053 109.494 124.898 109.446 124.623 109.274L123.828 108.789C123.697 108.732 123.042 109.353 123.897 110.116C124.059 110.265 124.214 110.43 124.302 110.526C124.471 110.704 124.323 110.685 124.09 110.595C123.703 110.404 123.303 110.242 122.892 110.11C122.831 110.161 122.324 110.963 123.597 111.78C123.664 111.815 123.733 111.846 123.805 111.87C124.072 111.987 123.845 112.031 123.52 112.031C123.175 112.032 122.83 112.004 122.49 111.949C122.321 111.875 122.14 113.164 123.714 113.457C124.034 113.513 123.771 113.579 123.427 113.727C123.427 113.727 121.741 114.285 124.025 114.825C123.819 114.945 123.6 115.043 123.372 115.115C122.703 115.263 123.912 116.123 124.855 116.179C125.064 116.148 125.031 116.373 124.261 116.691C124.12 116.746 124.38 117.28 125.234 117.155L125.549 117.118C125.616 117.115 125.1 117.284 125.145 117.479C125.189 117.673 126.047 117.822 125.913 117.815C125.913 117.815 120.792 117.641 121.069 118.06C121.42 118.609 122.968 118.503 122.968 118.503C122.968 118.503 120.88 118.82 120.847 119.104C120.813 119.387 123.24 119.276 123.24 119.276C123.24 119.276 120.894 119.915 121.024 120.406C121.153 120.897 123.696 119.897 123.696 119.897C123.696 119.897 121.977 120.855 122.157 121.128C122.336 121.401 124.185 120.474 124.185 120.474C124.185 120.474 122.549 121.968 123.07 122.04C123.153 122.053 123.237 122.037 123.31 121.996Z",
    fill: "url(#paint8_linear_1335_58653)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.109 115.76C130.589 115.967 130.077 116.307 129.73 116.09C129.086 115.662 128.569 115.068 128.233 114.372C128.159 113.976 128.117 113.574 128.109 113.171C128.333 113.431 128.587 113.801 128.587 113.801C128.756 113.979 128.866 113.982 128.787 113.746C128.748 113.626 128.681 113.408 128.601 113.205C128.186 112.135 129.187 111.867 129.26 111.983C129.439 112.402 129.642 112.811 129.867 113.208C129.57 111.646 130.732 111.513 130.766 111.658L130.921 112.373C130.985 112.673 131.037 113.072 131.086 112.828C131.402 111.275 132.718 111.845 132.555 112.175C131.97 113.326 131.486 114.525 131.109 115.76Z",
    fill: "url(#paint9_linear_1335_58653)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.109 115.76C130.589 115.967 130.077 116.307 129.73 116.09C129.086 115.662 128.569 115.068 128.233 114.372C128.159 113.976 128.117 113.574 128.109 113.171C128.333 113.431 128.587 113.801 128.587 113.801C128.756 113.979 128.866 113.982 128.787 113.746C128.748 113.626 128.681 113.408 128.601 113.205C128.186 112.135 129.187 111.867 129.26 111.983C129.439 112.402 129.642 112.811 129.867 113.208C129.57 111.646 130.732 111.513 130.766 111.658L130.921 112.373C130.985 112.673 131.037 113.072 131.086 112.828C131.402 111.275 132.718 111.845 132.555 112.175C131.97 113.326 131.486 114.525 131.109 115.76Z",
    fill: "url(#paint10_linear_1335_58653)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.692 116.42C132.617 116.476 132.561 116.554 132.53 116.642C132.5 116.73 132.496 116.825 132.52 116.916C132.52 116.916 133.158 117.033 133.314 117.36C133.34 117.155 133.292 116.948 133.177 116.775C133.063 116.603 132.891 116.477 132.692 116.42Z",
    fill: "url(#paint11_linear_1335_58653)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.275 116.271C132.261 116.302 132.237 116.325 132.206 116.337C132.175 116.349 132.141 116.349 132.11 116.335C132.094 116.329 132.08 116.32 132.068 116.308C132.056 116.297 132.046 116.282 132.039 116.267C132.033 116.251 132.03 116.235 132.03 116.218C132.03 116.201 132.033 116.184 132.04 116.169C132.046 116.152 132.056 116.138 132.068 116.125C132.08 116.113 132.095 116.103 132.111 116.097C132.128 116.091 132.145 116.088 132.162 116.089C132.18 116.089 132.197 116.094 132.213 116.102C132.228 116.108 132.242 116.118 132.254 116.13C132.265 116.143 132.274 116.157 132.28 116.173C132.286 116.189 132.288 116.206 132.287 116.223C132.287 116.24 132.282 116.256 132.275 116.271Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.734 145.375L154.431 143.666C156.422 144.537 157.247 143.349 157.665 142.69C158.084 142.031 158.057 141.973 158.498 141.707C158.94 141.44 158.991 140.892 158.332 140.603C157.672 140.315 157.006 141.183 156.576 140.917C154.66 139.729 154.5 135.907 154.514 134.435C154.513 134.169 153.535 134.415 153.706 135.228C153.745 135.421 153.614 135.305 153.466 135.123L153.125 134.67C153.053 134.567 152.458 134.961 152.83 135.565L153.005 135.849C153.096 136.012 152.936 135.903 152.727 135.772L152.127 135.406C152.034 135.365 151.536 135.834 152.172 136.417C152.292 136.528 152.411 136.658 152.478 136.726C152.546 136.794 152.49 136.848 152.318 136.779C152.031 136.625 151.732 136.494 151.424 136.388C151.403 136.437 150.994 137.029 151.959 137.646C152.009 137.674 152.062 137.697 152.117 137.715C152.319 137.803 152.147 137.838 151.9 137.84C151.64 137.84 151.38 137.817 151.123 137.772C150.998 137.718 150.857 138.693 152.049 138.91C152.288 138.956 152.086 139.004 151.833 139.12C151.833 139.12 150.555 139.532 152.271 139.96C152.116 140.051 151.951 140.124 151.779 140.179C151.276 140.289 152.187 140.94 152.903 140.981C153.056 140.958 153.033 141.129 152.449 141.366C152.347 141.405 152.539 141.813 153.196 141.693L153.432 141.673C153.487 141.665 153.097 141.799 153.126 141.941C153.155 142.083 153.806 142.199 153.71 142.196C153.71 142.196 149.867 142.069 150.056 142.379C150.317 142.792 151.488 142.714 151.488 142.714C151.488 142.714 149.926 142.957 149.887 143.167C149.847 143.376 151.69 143.308 151.69 143.308C151.69 143.308 149.919 143.79 150.018 144.158C150.117 144.525 152.043 143.748 152.043 143.748C152.043 143.748 150.733 144.47 150.882 144.678C151.031 144.886 152.399 144.182 152.399 144.182C152.399 144.182 151.165 145.308 151.559 145.357C151.614 145.382 151.675 145.388 151.734 145.375Z",
    fill: "url(#paint12_linear_1335_58653)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.631 140.647C157.243 140.807 156.859 141.06 156.592 140.898C156.108 140.573 155.718 140.125 155.464 139.601C155.403 139.299 155.367 138.993 155.358 138.686C155.531 138.885 155.721 139.162 155.721 139.162C155.848 139.302 155.928 139.298 155.868 139.123C155.808 138.948 155.791 138.869 155.729 138.712C155.422 137.93 156.17 137.706 156.222 137.794C156.275 137.882 156.717 138.892 156.683 138.715C156.462 137.543 157.333 137.438 157.358 137.559L157.465 138.118C157.514 138.347 157.549 138.653 157.587 138.463C157.834 137.275 158.826 137.709 158.703 137.96C158.27 138.823 157.911 139.722 157.631 140.647Z",
    fill: "url(#paint13_linear_1335_58653)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.631 140.647C157.243 140.807 156.859 141.06 156.592 140.898C156.108 140.573 155.718 140.125 155.464 139.601C155.403 139.299 155.367 138.993 155.358 138.686C155.531 138.885 155.721 139.162 155.721 139.162C155.848 139.302 155.928 139.298 155.868 139.123C155.808 138.948 155.791 138.869 155.729 138.712C155.422 137.93 156.17 137.706 156.222 137.794C156.275 137.882 156.717 138.892 156.683 138.715C156.462 137.543 157.333 137.438 157.358 137.559L157.465 138.118C157.514 138.347 157.549 138.653 157.587 138.463C157.834 137.275 158.826 137.709 158.703 137.96C158.27 138.823 157.911 139.722 157.631 140.647Z",
    fill: "url(#paint14_linear_1335_58653)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.814 141.165C158.755 141.203 158.708 141.258 158.68 141.323C158.651 141.388 158.643 141.459 158.655 141.529C158.655 141.529 159.136 141.617 159.25 141.861C159.269 141.713 159.236 141.562 159.157 141.435C159.077 141.308 158.956 141.213 158.814 141.165Z",
    fill: "url(#paint15_linear_1335_58653)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.509 141.031C158.504 141.042 158.497 141.052 158.488 141.061C158.479 141.07 158.468 141.076 158.457 141.081C158.445 141.085 158.433 141.088 158.42 141.087C158.408 141.087 158.395 141.084 158.384 141.079C158.36 141.069 158.341 141.05 158.331 141.026C158.321 141.003 158.32 140.976 158.329 140.952C158.341 140.928 158.361 140.91 158.386 140.9C158.41 140.891 158.438 140.891 158.463 140.9C158.486 140.912 158.503 140.932 158.512 140.956C158.521 140.98 158.52 141.007 158.509 141.031Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.796 149.727L106.029 146.38C109.923 148.084 111.508 145.739 112.356 144.47C113.203 143.202 113.121 143.062 113.984 142.545C114.847 142.029 114.948 140.952 113.688 140.401C112.554 139.904 111.102 141.53 110.257 141.011C106.515 138.693 106.199 131.219 106.225 128.34C106.224 127.822 104.294 128.299 104.646 129.898C104.724 130.269 104.47 130.035 104.183 129.695L103.508 128.804C103.367 128.606 102.211 129.376 102.933 130.561C103.061 130.759 103.192 130.966 103.274 131.118C103.45 131.429 103.143 131.21 102.736 130.967L101.563 130.247C101.373 130.163 100.4 131.079 101.646 132.227C101.881 132.446 102.096 132.683 102.245 132.832C102.495 133.091 102.275 133.059 101.928 132.933C101.358 132.649 100.768 132.41 100.161 132.218C100.077 132.292 99.3237 133.478 101.209 134.679C101.307 134.732 101.409 134.777 101.514 134.813C101.907 134.985 101.572 135.052 101.092 135.049C100.583 135.051 100.075 135.01 99.5727 134.929C99.3218 134.819 99.0535 136.723 101.381 137.152C101.849 137.24 101.457 137.334 100.957 137.556C100.957 137.556 98.4652 138.364 101.835 139.172C101.532 139.35 101.209 139.493 100.874 139.6C99.8892 139.817 101.668 141.082 103.066 141.169C103.37 141.127 103.326 141.451 102.186 141.918C101.98 142.002 102.362 142.792 103.621 142.604C103.779 142.583 103.944 142.577 104.09 142.556C104.235 142.536 103.423 142.803 103.489 143.084C103.554 143.365 104.818 143.595 104.623 143.58C104.623 143.58 97.0968 143.332 97.4802 143.94C97.9967 144.75 100.282 144.59 100.282 144.59C100.282 144.59 97.2328 145.07 97.1504 145.481C97.0679 145.892 100.686 145.732 100.686 145.732C100.686 145.732 97.2205 146.672 97.4126 147.391C97.6047 148.11 101.351 146.646 101.351 146.646C101.351 146.646 98.7896 148.045 99.0782 148.47C99.3667 148.894 102.097 147.51 102.097 147.51C102.097 147.51 99.6856 149.694 100.44 149.811C100.565 149.823 100.69 149.794 100.796 149.727Z",
    fill: "url(#paint16_linear_1335_58653)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.297 140.523C111.513 140.829 110.78 141.331 110.257 141.011C109.312 140.377 108.553 139.504 108.058 138.48C107.936 137.893 107.866 137.297 107.85 136.698C108.176 137.081 108.539 137.648 108.539 137.648C108.795 137.909 108.95 137.912 108.839 137.571C108.784 137.385 108.682 137.069 108.531 136.789C107.917 135.224 109.395 134.815 109.497 134.983C109.599 135.15 110.465 137.136 110.396 136.789C109.959 134.491 111.672 134.289 111.717 134.528L111.926 135.624C112.018 136.067 112.114 136.679 112.166 136.293C112.635 134.004 114.574 134.846 114.342 135.301C113.516 136.982 112.832 138.729 112.297 140.523Z",
    fill: "url(#paint17_linear_1335_58653)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.297 140.523C111.513 140.829 110.78 141.331 110.257 141.011C109.312 140.377 108.553 139.504 108.058 138.48C107.936 137.893 107.866 137.297 107.85 136.698C108.176 137.081 108.539 137.648 108.539 137.648C108.795 137.909 108.95 137.912 108.839 137.571C108.784 137.385 108.682 137.069 108.531 136.789C107.917 135.224 109.395 134.815 109.497 134.983C109.599 135.15 110.465 137.136 110.396 136.789C109.959 134.491 111.672 134.289 111.717 134.528L111.926 135.624C112.018 136.067 112.114 136.679 112.166 136.293C112.635 134.004 114.574 134.846 114.342 135.301C113.516 136.982 112.832 138.729 112.297 140.523Z",
    fill: "url(#paint18_linear_1335_58653)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.632 141.5C114.523 141.583 114.44 141.697 114.394 141.827C114.349 141.957 114.343 142.097 114.377 142.231C114.377 142.231 115.316 142.402 115.544 142.891C115.584 142.588 115.514 142.282 115.347 142.027C115.179 141.771 114.926 141.584 114.632 141.5Z",
    fill: "url(#paint19_linear_1335_58653)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.02 141.278C114.005 141.312 113.98 141.342 113.948 141.362C113.916 141.382 113.879 141.392 113.842 141.392C113.804 141.391 113.767 141.379 113.736 141.357C113.705 141.336 113.682 141.306 113.668 141.271C113.654 141.236 113.651 141.197 113.659 141.161C113.667 141.124 113.686 141.09 113.713 141.064C113.74 141.038 113.774 141.021 113.812 141.014C113.849 141.008 113.887 141.012 113.921 141.028C113.968 141.048 114.004 141.086 114.022 141.133C114.041 141.179 114.04 141.232 114.02 141.278Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8718 25.5715C77.8718 25.5715 79.6962 22.294 81.8696 20.8023L83.2813 22.2237C83.2813 22.2237 79.8771 25.9632 79.8645 26.6899L77.8718 25.5715Z",
    fill: "url(#paint20_linear_1335_58653)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.299 25.3394C38.299 25.3394 41.1074 26.925 42.3801 28.7975L41.1532 29.9972C41.1532 29.9972 37.9516 27.0536 37.3322 27.0287L38.299 25.3394Z",
    fill: "url(#paint21_linear_1335_58653)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M134.042 62.7084C134.042 62.7084 136.263 63.959 137.274 65.4191L136.306 66.3691C136.306 66.3691 133.776 64.0436 133.282 64.0284L134.042 62.7084Z",
    fill: "url(#paint22_linear_1335_58653)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4304 36.3888C91.7709 36.4112 91.1018 36.4553 90.4565 36.445L91.5833 39.8089C92.2357 39.8029 92.8953 39.7805 93.5549 39.7581C96.9409 39.6526 100.449 39.5355 101.064 41.4117L99.9393 38.0424C99.3198 36.1771 95.8165 36.2832 92.4304 36.3888Z",
    fill: "url(#paint23_linear_1335_58653)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.057 41.4098L99.9327 38.0405C100.488 39.7414 99.4212 41.5102 92.6691 45.7284L93.3671 49.1962C94.5194 48.4045 95.9002 47.5509 97.2432 46.739C100.893 44.5324 101.667 43.2383 101.057 41.4098Z",
    fill: "url(#paint24_linear_1335_58653)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M164.956 54.6537L169.56 55.8782L168.913 57.7138L164.411 56.2555L164.956 54.6537Z",
    fill: "url(#paint25_linear_1335_58653)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2902 1.23586L53.5733 1.93115L52.5238 4.6406L48.3907 3.6027L49.2902 1.23586Z",
    fill: "url(#paint26_linear_1335_58653)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.526 136L105.087 137.727L106.904 137.727L105.434 138.795L105.996 140.523L104.526 139.455L103.057 140.523L103.618 138.795L102.148 137.727L103.965 137.727L104.526 136Z",
    fill: "#FFFA66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1335_58653",
    x1: 52.3126,
    y1: 68.4868,
    x2: 58.1281,
    y2: 136.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1335_58653",
    x1: 60.0306,
    y1: 67.4918,
    x2: 84.8374,
    y2: 123.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1335_58653",
    x1: 71.1285,
    y1: 89.7612,
    x2: 70.2398,
    y2: 104.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1335_58653",
    x1: 78.2546,
    y1: 66.2525,
    x2: 84.0681,
    y2: 133.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1335_58653",
    x1: 106.249,
    y1: 68.9207,
    x2: 108.593,
    y2: 96.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1335_58653",
    x1: 109.361,
    y1: 68.5203,
    x2: 119.36,
    y2: 90.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1335_58653",
    x1: 113.834,
    y1: 77.496,
    x2: 113.473,
    y2: 83.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1335_58653",
    x1: 116.701,
    y1: 68.0202,
    x2: 119.045,
    y2: 95.2912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1335_58653",
    x1: 125.852,
    y1: 107.459,
    x2: 127.24,
    y2: 123.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1335_58653",
    x1: 127.692,
    y1: 107.221,
    x2: 133.577,
    y2: 120.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1335_58653",
    x1: 130.323,
    y1: 112.507,
    x2: 130.116,
    y2: 116.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1335_58653",
    x1: 132.012,
    y1: 106.928,
    x2: 133.397,
    y2: 122.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1335_58653",
    x1: 153.657,
    y1: 134.404,
    x2: 154.699,
    y2: 146.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1335_58653",
    x1: 155.037,
    y1: 134.223,
    x2: 159.485,
    y2: 144.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1335_58653",
    x1: 157.025,
    y1: 138.217,
    x2: 156.869,
    y2: 140.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1335_58653",
    x1: 158.302,
    y1: 134.007,
    x2: 159.344,
    y2: 146.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1335_58653",
    x1: 104.549,
    y1: 128.281,
    x2: 106.587,
    y2: 151.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1335_58653",
    x1: 107.248,
    y1: 127.933,
    x2: 115.937,
    y2: 147.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1335_58653",
    x1: 111.14,
    y1: 135.728,
    x2: 110.828,
    y2: 141.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1335_58653",
    x1: 113.632,
    y1: 127.499,
    x2: 115.67,
    y2: 151.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1335_58653",
    x1: 75.506,
    y1: 25.9876,
    x2: 79.5791,
    y2: 21.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1335_58653",
    x1: 37.7883,
    y1: 25.9833,
    x2: 41.7838,
    y2: 29.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1335_58653",
    x1: 133.639,
    y1: 63.2345,
    x2: 136.798,
    y2: 66.0405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1335_58653",
    x1: 86.5606,
    y1: 38.2687,
    x2: 99.0311,
    y2: 34.0726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#590B09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1335_58653",
    x1: 87.5026,
    y1: 42.9519,
    x2: 100.541,
    y2: 38.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1335_58653",
    x1: 164.764,
    y1: 55.0942,
    x2: 169.208,
    y2: 57.0394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1335_58653",
    x1: 48.9998,
    y1: 1.89934,
    x2: 52.9642,
    y2: 3.63451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A62621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#CF3735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EB4243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F54648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#831811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3532"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBird);
export default __webpack_public_path__ + "static/media/group_bird.d81a76a47c7694ec8d1fb103d55e864f.svg";
export { ForwardRef as ReactComponent };